var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.881 250.14C194.806 250.14 250.882 194.066 250.882 125.141C250.882 56.2154 194.806 0.139893 125.881 0.139893C124.607 0.139893 123.572 1.17424 123.572 2.44877C123.572 3.72484 124.607 4.75771 125.881 4.75771C192.26 4.75771 246.264 58.7613 246.264 125.141C246.264 191.518 192.26 245.522 125.881 245.522C59.5034 245.522 5.49965 191.518 5.49965 125.141C5.49965 123.865 4.46532 122.832 3.19085 122.832C1.91634 122.832 0.881836 123.865 0.881836 125.141C0.881836 194.066 56.9558 250.14 125.881 250.14Z",
    fill: "#07BB02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGreen);
export default __webpack_public_path__ + "static/media/circle-green.c06eb49c012965319a7466d4e06c2881.svg";
export { ForwardRef as ReactComponent };